module.exports = __webpack_public_path__ + "img/0070.8e8d8f05.jpg";